import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { InlineToastComponent } from './inline-toast.component';

@NgModule({
    declarations: [InlineToastComponent],
    imports: [CommonModule, TranslateModule],
    exports: [InlineToastComponent],
})
export class InlineToastModule {}